function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import mediaQueryBreakpoints from '../../base/grid';

// converting "1440px" to 1440
var MEDIA_QUERY_BREAKPOINTS = Object.entries(mediaQueryBreakpoints().global).reduce((acc, _ref) => {
  var _ref2 = _slicedToArray(_ref, 2),
    key = _ref2[0],
    value = _ref2[1];
  acc[key] = parseInt(value.split('px')[0], 10);
  return acc;
}, {});
function processQuery(query) {
  switch (query) {
    case '>mobile':
      return "(min-width: 321px)";
    case '>=mobile':
      return "(min-width: 320px)";
    case '>tablet':
      return "(min-width: ".concat(MEDIA_QUERY_BREAKPOINTS.tabletMinWidth + 1, "px)");
    case '>=tablet':
      return "(min-width: ".concat(MEDIA_QUERY_BREAKPOINTS.tabletMinWidth, "px)");
    case '>desktop':
      return "(min-width: ".concat(MEDIA_QUERY_BREAKPOINTS.desktopMinWidth + 1, "px)");
    case '>=desktop':
      return "(min-width: ".concat(MEDIA_QUERY_BREAKPOINTS.desktopMinWidth, "px)");
    case '>lrg-desktop':
      return "(min-width: ".concat(MEDIA_QUERY_BREAKPOINTS.desktopMaxWidth + 1, "px)");
    case '>=lrg-desktop':
      return "(min-width: ".concat(MEDIA_QUERY_BREAKPOINTS.desktopMaxWidth, "px)");
    case '<mobile':
      return "(max-width: 319px)";
    case '<=mobile':
      return "(max-width: 320px)";
    case '<tablet':
      return "(max-width: ".concat(MEDIA_QUERY_BREAKPOINTS.tabletMinWidth - 1, "px)");
    case '<=tablet':
      return "(max-width: ".concat(MEDIA_QUERY_BREAKPOINTS.tabletMinWidth, "px)");
    case '<desktop':
      return "(max-width: ".concat(MEDIA_QUERY_BREAKPOINTS.desktopMinWidth - 1, "px)");
    case '<=desktop':
      return "(max-width: ".concat(MEDIA_QUERY_BREAKPOINTS.desktopMinWidth, "px)");
    case '<lrg-desktop':
      return "(max-width: ".concat(MEDIA_QUERY_BREAKPOINTS.desktopMaxWidth - 1, "px)");
    case '<=lrg-desktop':
      return "(max-width: ".concat(MEDIA_QUERY_BREAKPOINTS.desktopMaxWidth, "px)");
    default:
      throw new Error("Unrecognised arg in `media('".concat(query, "')`, please read the `media` function here in fe-brary/src/js/emotion/utility/media.js to see supported args."));
  }
}
function media() {
  for (var _len = arguments.length, queries = new Array(_len), _key = 0; _key < _len; _key++) {
    queries[_key] = arguments[_key];
  }
  if (arguments.length < 1) {
    throw new Error('Must supply at least one argument to `media`.');
  }
  var processedQueries = queries.map(query => processQuery(query));
  // currently multiple processedQueries are just joined by logical AND
  return "@media".concat(processedQueries.join(' and '));
}
export default media;